import {
    createSelector,
    createFeatureSelector,
    ActionReducerMap,
    MetaReducer
} from '@ngrx/store';

import * as fromRoot from '../../store/app.reducers';
import * as fromItems from './items/items.reducers';

export interface ItemsState {
    favourites: fromItems.State;
}

export interface State extends fromRoot.AppState {
    favourites: ItemsState;
}

export const reducers: ActionReducerMap<any> = {
    favourites: fromItems.reducer
};

export const metaReducers: MetaReducer<State>[] = [];

/**
 * A selector function is a map function factory. We pass it parameters and it
 * returns a function that maps from the larger state tree into a smaller
 * piece of state. This selector simply selects the `books` state.
 *
 * Selectors are used with the `select` operator.
 *
 * ```ts
 * class MyComponent {
 *   constructor(state$: Observable<State>) {
 *     this.booksState$ = state$.pipe(select(getBooksState));
 *   }
 * }
 * ```
 */

/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getFavouritesState = createFeatureSelector<ItemsState>('favourites');

export const getFavouritesEntitiesState = createSelector(
    getFavouritesState,
    state => state.favourites
);

export const {
    selectEntities: getFavouritesEntities,
    selectTotal: getTotalFavourites,
} = fromItems.adapter.getSelectors(getFavouritesEntitiesState);


export const getFavouritesIds = createSelector(
    getFavouritesEntitiesState,
    fromItems.getFavouritesIds
);

export const getAllFavourites = createSelector(
    getFavouritesEntitiesState,
    fromItems.getAllFavourites
);

export const getLoadingFavourites = createSelector(
    getFavouritesEntitiesState,
    fromItems.isLoadingFavourites
);

export const getLoadingFavouriteFn = (catalogueId) => createSelector(
    getFavouritesEntitiesState,
    fromItems.isLoadingFavouriteFn(catalogueId)
);
